export const LANGUAGES_TRANSLATE = {
    languages: {
        breadcrumbName: "Languages",
        messages: {
            create: "Language created successfully",
            update: "Language updated successfully",
            delete: "Language deleted successfully",
            recover: "Language recovered successfully"
        },
        list: {
            table: {
                columns: {
                    id: "ID",
                    name: "Name",
                    tag: "Tag"
                }
            },
            filters: {
                fields: {
                    active: {
                        label: "Status",
                        placeholder: "Select status",
                        url: "status"
                    }
                }
            },
            dialog: {
                delete: {
                    title: "Deactivate language",
                    body: "Are you sure you want to deactivate the language with ID {{id}}?",
                    save: { text: "Yes, deactivate" },
                    back: { text: "Back" }
                }
            }
        },
        save: {
            form: {
                fields: {
                    name: {
                        label: "Name",
                        placeholder: "Enter the language name"
                    },
                    tag: {
                        label: "Tag",
                        placeholder: "e.g. en-US"
                    },
                    active: {
                        label: "Active"
                    },
                    countryFlag: {
                        label: "Flag icon",
                        noResultsLabel: "No image selected",
                        noResultsDescription: "Click to select a flag image",
                        textButton: "Select image",
                        changeTextButton: "Change image"
                    }
                }
            }
        }
    }
};
